import { Outlet } from "react-router-dom";
import React from "react";
import { AuthProvider } from "../auth";
import { StudentsProvider } from "../context/students";
import { VerificationStatusProvider } from "../context/status/StatusesContext";
import ProductFruits from "../components/product-fruits/ProductFruits";
import { FeaturesProvider } from "../context/features";

const AuthAndStudentsLayout = () => (
    <AuthProvider>
        <FeaturesProvider>
            <StudentsProvider>
                <VerificationStatusProvider>
                    <Outlet />
                    <ProductFruits />
                </VerificationStatusProvider>
            </StudentsProvider>
        </FeaturesProvider>
    </AuthProvider>
);

export default AuthAndStudentsLayout;
